<template>
  <div class="dblWarningContainer">
    <!-- 修改後 -->
    <div class="dblWarning">
      <div class="dblWarning__title">解锁合盘须知</div>
      <div class="dblWarning__content">
        <div>
          解锁后合盘内容将固定为当前资料，若后续修改帐户资料：
          <br />
          <ul>
            <li>已购买的合盘不会更新</li>
            <li>如需最新资料的合盘解读，需重新购买</li>
            <li>此购买不予退款</li>
          </ul>
        </div>
      </div>
      <div class="dblWarning__checkbox">
        <label for="isOk">
          <div class="checkbox" :class="{ active: isOk }">
            <input type="checkbox" v-model="isOk" id="isOk" />
            <div class="checkmark"></div>
          </div>
          <div>我已了解修改资料后，已购买合盘不会更新的说明。</div>
        </label>
      </div>
      <div class="dblWarning__btn">
        <div class="dblWarning__btn__cancel" @click="cancel">返回修改资料</div>
        <div
          class="dblWarning__btn__ok"
          @click="save"
          :class="{ disabled: !isOk }"
        >
          确认并付款
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      event: null,
      isOk: false,
    };
  },
  created() {
    Vue.prototype.$dblWarning = (event) => {
      this.dblWarning = true;
      this.event = event;
    };
  },
  computed: {
    IsUnlockBC() {
      if (this.$store.state.userBeEdit) {
        return this.$store.state.userBeEdit.IsUnlockBC;
      } else {
        return false;
      }
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    save() {
      this.$emit("ok");
    },
  },
};
</script>
<style lang="scss">
@import "@/scss/_mixin.scss";
.dblWarningContainer {
  @include overlay;
  width: 100vw;
  height: 100vh;
  background: rgba(240, 242, 244, 0.15);
  backdrop-filter: blur(30px);
  .dblWarning {
    width: 628px;
    padding: 32px 62px;
    background: #f0f2f4;
    box-shadow: -4px -4px 16px rgba(238, 109, 175, 0.22), -4px -4px 10px rgba(238, 109, 175, 0.22),
      4px 4px 25px rgba(0, 0, 0, 0.3);
    border-radius: 100px;
    @include mobile {
      width: 296px;
      padding: 24px 39px 28px;
      background: #f0f2f4;
      box-shadow: -4px -4px 12px rgba(238, 109, 175, 0.22), -2px -2px 8px rgba(238, 109, 175, 0.22),
        4px 4px 20px rgba(0, 0, 0, 0.2);
      border-radius: 80px;
    }
    &__title {
      text-align: center;
      letter-spacing: 0.016em;

      font-weight: 700;
      font-size: 46px;
      line-height: 68px;
      color: #17445c;
      @include mobile {
        font-size: 20px;
        line-height: 30px;
        color: #798da5;
      }
    }
    &__subtitle {
      font-weight: 500;
      line-height: 1;
      font-size: 24px;
      text-align: center;
      letter-spacing: 0.04em;
      color: #868686;
      @include pad {
        font-size: 16px;
      }
    }
    &__content {
      margin-top: 36px;
      display: flex;
      color: #9b9b9b;
      font-size: 20px;
      line-height: 1;
      font-weight: 700;
      &__icon {
        margin-right: 12px;
        @include mobile {
          margin-right: 8px;
        }
      }
      @include mobile {
        margin-top: 16px;
        font-size: 16px;
        line-height: 24px;
      }
    }
    &__checkbox {
      margin-top: 36px;
      display: flex;
      color: #9b9b9b;
      font-weight: 400;
      font-size: 20px;
      line-height: 30px;
      label {
        display: flex;
        align-items: flex-start;
      }
      .checkbox {
        position: relative;
        display: inline-block;

        transform: translatex(-4px);
        cursor: pointer;
        &:before {
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          margin-right: 4px;
          width: 22px;
          height: 22px;
          flex-shrink: 0;
          transform: translate(-50%, -50%);
          background: #f0f2f4;
          border: 1px solid #9b9b9b;
          box-shadow: -1px -1px 4px rgba(238, 109, 175, 0.22), 2px 2px 8px rgba(0, 0, 0, 0.1);
          border-radius: 3px;
          @include mobile {
            margin-right: 2px;
            margin-top: 4px;
          }
        }
        &.active:before {
          background: #798da5;
          border: 1px solid #9b9b9b;
        }
      }
      input:checked ~ .checkmark {
        position: absolute;
        left: 50%;
        top: 40%;
        z-index: 999;
        width: 8px;
        height: 13px;
        border: solid #fff;
        border-width: 0px 3px 3px 0;
        transform: translate(-50%, -50%) rotate(45deg);
        @include pad {
          top: 50%;
        }
      }
      input {
        visibility: hidden;
        margin-right: 12px;
      }
      @include mobile {
        margin-top: 16px;
        font-size: 16px;
        line-height: 24px;
      }
    }
    &__btn {
      margin-top: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      @include mobile {
        justify-content: space-between;
      }
      &__cancel {
        @include btn-default(176px, 56px,  20px);
        font-size: 20px;
        line-height: 30px;
        transition: 0.2s;
        @include mobile {
          height: 40px;
          font-size: 14px;
          @include btn(50%, 40px, #d9d9d9, #000, 20px);
        }
        &:hover {
          color: #fff;
        }
        &.disabled {
          pointer-events: none;
          border: 1px solid #d9d9d9;
          background-color: #f0f2f4;
          color: rgba(155, 155, 155, 0.7);
        }
        background: #fff;
        color: #798da5;
        border: 1px solid #798da5;
        margin-right: 16px;

      }
      &__ok {
        
        @include btn-default(176px, 56px, 20px);
        font-size: 20px;
        line-height: 30px;
        border: 2px solid rgba(121, 141, 165, 0.3);
        text-align: center;
        color: #ffffff;
        @include mobile {
          font-size: 14px;
          line-height: 21px;
          @include btn-default(50%, 40px, 20px);
        }
        &:hover {
          border: 0;
          background-color: rgba($color: $secondary-color-2, $alpha: 0.6);
          color: rgba($color: $secondary-color-3, $alpha: 0.6);
        }
        &:active {
          border: 0;
          background-color: $secondary-color-2;
          color: $secondary-color-3;
        }
        &.disabled {
          pointer-events: none;
          border: 1px solid #d9d9d9;
          background-color: #f0f2f4;
          color: rgba(155, 155, 155, 0.7);
        }
      }
    }
  }
}
</style>
